import { KeywordsTrafficSource } from "app/pages/sales-intelligence/domain/leads/types/enums";
import { filterUsageMap } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterDefinition";

import KeywordsFilter from "../../components/filters/KeywordsFilter/KeywordsFilter";
import KeywordsFilterResult from "../../components/filters/KeywordsFilter/KeywordsFilterResult";
import { leadsFilterApiCategory } from "../../types/leadsFilterApiCategory";
import { leadsFilterCategoryMap } from "../../types/leadsFilterCategory";
import { defineLeadsFilter } from "../defineLeadsFilter";

import FindKeywordsFilter from "./KeywordsFilter";

export const keywordsDefinition = defineLeadsFilter({
    key: "keywords",
    apiCategory: leadsFilterApiCategory.keywords,
    category: leadsFilterCategoryMap.website,
    usages: [filterUsageMap.search, filterUsageMap.territory],
    trackingName: "Keywords",
    titleKey: { key: "si.lead_gen_filters.keywords.name" },

    render: () => ({
        tooltipText: { key: "si.lead_gen_filters.keywords.tooltip" },
        filter: new FindKeywordsFilter({
            options: [KeywordsTrafficSource.Organic, KeywordsTrafficSource.Paid, KeywordsTrafficSource.Both],
        }),
        filterView: KeywordsFilter,
        filterResultView: KeywordsFilterResult,
    }),
});
